module.exports = __webpack_public_path__ + "static/media/logo-blue-large.7ebdf19b.png";